module.exports = __webpack_public_path__ + "img/hontai_L2537.6e0331e4.png";